module.exports = __webpack_public_path__ + "img/feefo_logo_yellow.0fb6523.png";